export default __webpack_public_path__ + "static/media/sponsor-banner-ms.b33eafb0.webp";